import React from "react";
import { Box, Button } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { communityCreateDebatePath } from "../../utils/community";

const CommunityDebateCta = ({ sport, playerIds = [] }) => {
  const ids = playerIds.filter(Boolean);
  if (ids.length < 2) return null;
  return (
    <Box sx={{ mb: 3 }}>
      <Button
        component={RouterLink}
        to={communityCreateDebatePath(sport, { a: ids[0], b: ids[1] })}
        variant="outlined"
      >
        Create Community Debate
      </Button>
    </Box>
  );
};

export default CommunityDebateCta;
